import { AUTO_SAVE_STATUS } from "src/components/collections/knowledge-sources/explore/ExploreTab.consts";

const createExploreAutoSaveSlice = (set) => ({
  exploreSaveStatus: AUTO_SAVE_STATUS.IDLE,
  setExploreSaveStatus: (status) => set({ exploreSaveStatus: status }),
  resetExploreSaveStatus: () => set({ exploreSaveStatus: AUTO_SAVE_STATUS.IDLE })
});

export default createExploreAutoSaveSlice;
